import { CheckIcon, ExclamationCircleIcon } from '@heroicons/react/outline';
import { Dialog, Transition } from '@headlessui/react';
import { Fragment } from 'react';
import classNames from 'classnames';

export function Modal({
  type = 'success',
  buttonText = 'Button Text',
  headline = 'Headline',
  onClose = () => null,
  setShow = () => null,
  show = false,
  text = 'Text',
  noIcon,
  fullWidth,
}) {
  return (
    <Transition.Root show={show} as={Fragment}>
      <Dialog as="div" className="relative z-40" onClose={setShow}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div
          className={classNames(
            'fixed z-10 inset-0 overflow-y-auto pb-24 pt-20 px-6 lg:py-10',
            {
              'lg:pl-[300px]': !fullWidth,
            },
          )}
        >
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enterTo="opacity-100 translate-y-0 sm:scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          >
            <div className="flex items-center min-h-full">
              <Dialog.Panel className="bg-white px-4 pt-5 pb-4 mx-auto relative overflow-hidden rounded-lg shadow-xl transition-all sm:max-w-md sm:p-6">
                {!noIcon && (
                  <div
                    className={classNames(
                      'mx-auto flex items-center justify-center h-12 w-12 rounded-full',
                      {
                        'bg-green-100': type === 'success',
                        'bg-red-100': type === 'error',
                      },
                    )}
                  >
                    {type === 'success' ? (
                      <CheckIcon
                        className="h-6 w-6 text-green-600"
                        aria-hidden="true"
                      />
                    ) : (
                      <ExclamationCircleIcon
                        className="h-6 w-6 text-red-600"
                        aria-hidden="true"
                      />
                    )}
                  </div>
                )}
                <div className="mt-3 text-center sm:mt-5">
                  <Dialog.Title
                    as="h3"
                    className="text-lg leading-6 font-medium text-gray-900"
                  >
                    {headline}
                  </Dialog.Title>
                  <div className="mt-2">
                    <p className="text-sm text-gray-500">{text}</p>
                  </div>
                </div>

                <div className="mt-5 sm:mt-6">
                  <button
                    type="button"
                    className="inline-flex justify-center w-full rounded-md border border-transparent shadow-sm px-4 py-2 bg-brand-1 text-base font-medium text-white hover:bg-brand-1/80 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brand-1/80 sm:text-sm"
                    onClick={() => {
                      if (typeof onClose === 'function') {
                        onClose();
                      }

                      setShow(false);
                    }}
                  >
                    {buttonText}
                  </button>
                </div>
              </Dialog.Panel>
            </div>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition.Root>
  );
}
